export const Bio = {
  name: "Sagar Arya",
  roles: ["Programmer","Tech Enthusiast", "Web Developer", "Software Engineer"],
  description:
    "I am an enthusiastic and adaptable person, constantly seeking opportunities to tackle fresh obstacles. Fueled by a strong desire for knowledge, I am committed to producing excellent outcomes. Possessing an optimistic outlook and an openness to growth, I am prepared to make a significant impact and attain notable accomplishments.",
  github: "https://github.com/sagar10arya",
  resume:
    "https://drive.google.com/file/d/1A2eIIls-5_zIh4ENVkwbAwiitnC309L8/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sagar-arya-94398b192/",
  twitter: "https://twitter.com/sagar10___",
  insta: "https://www.instagram.com/sagar10___/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/570px-C_Programming_Language.svg.png?20201031132917",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/180px-ISO_C%2B%2B_Logo.svg.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "SQL",
        image:
          "https://w7.pngwing.com/pngs/552/345/png-transparent-sql-database-computer-icons-sql-icon-blue-text-rectangle-thumbnail.png",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "PHP",
        image: "https://www.php.net/images/logos/php-logo.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAATlBMVEX////1+f58sPtOlPmAsvpzq/sXc/gGafhup/ry9/7Q4v0LbPhQlvlBjPnA2fwmfPgbdfgQb/inyvyYwfzj7v5gn/pDjvk0hflKkvmIt/tmn/cMAAAAXElEQVR4Ae2OMRZAMBAFEysZAAjk/hf1ol4FpZdpfjFTfPOVjH1WhZTWeXxV675pkY5Er+mh8CDj1M/AogQrgDhrwgSbEtT7AZIeOjiNxgCStvx3EGJc7jBt5i0XXhkEtjflcGYAAAAASUVORK5CYII=",
    role: "Software Engineering Intern",
    company: "OneVarsity",
    date: "August 2022 - November 2022",
    desc: "Designed and developed the frontend of the company’s website, ensuring a modern and intuitive user experience.",
    skills: ["JavaScript", "HTML", "CSS", "Google Cloud Platform"],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://pbs.twimg.com/profile_images/1153361815096549377/s542Apw6_400x400.jpg",
    school: "Jawaharlal Nehru University, New Delhi",
    date: "Aug 2019 - May 2024",
    grade: "7.4 CGPA",
    degree: " Integrated Bachelor of Technology - BTech, Computer Science and Engineering + Master of Science - Management",
    desc: " Courses : Data Structures and Algorithms, Object Oriented Programming, Database Management System Operating System, Machine Learning, Bussiness Analytics, Finance Management, Economics etc.",
  },
  
];

export const projects = [
  {
    id: 0,
    title: "CryptoVerse",
    date: "Aug 2023 - Sep 2023",
    description:
      "React application that contains everything about cryptocurrencies, crypto markets and exchanges, latest news and much more.",
    image: require("../images/cryptoverse.png"),
    tags: ["React Js", "Redux", "Rapid API", "Ant-Design", "Chart.js"],
    category: "web app",
    github: "https://github.com/sagar10arya/Crypto-World",
    webapp: "https://cyptoworld-47ef34.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },
  {
    id: 1,
    title: "Intrusion Detection System",
    date: "Aug 2022 - Dec 2022",
    description:
      "Intrusion detection systems (IDS) are an important component of modern cybersecurity, helping to protect computer networks and systems from unauthorized access and attacks. Machine learning (ML) techniques  have shown great promise in improving the accuracy and effectiveness of IDS, by enabling automated detection and classification of different types of network traffic and user behavior.",
    image: require("../images/intrusion.jpg"),
    tags: ["Python", "Machine Learning"],
    category: "machine learning",
    github: "https://github.com/sagar10arya",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
      {
        name: "Shivam Yadav",
        img: "https://media.licdn.com/dms/image/D4D03AQG2iJK4dt6WkA/profile-displayphoto-shrink_400_400/0/1702140836050?e=1724284800&v=beta&t=arNpf3sbzKunxziycbv9YZB02qSrV1VH5REujuRWedk",
        linkedin: "https://www.linkedin.com/in/shivam-yadav-a35603275/",
        // github: "https://github.com/upasana0710",
      },

    ],
  },
  {
    id: 2,
    title: "Compiler Optimisation Using Machine Learning",
    date: "Jan 2023 - Mar 2023",
    description:
      "Researched Compiler Optimization using Machine Learning methodologies, Explored techniques for collecting and preprocessing relevant data, Studied the process of training machine learning models tailored for compiler optimization, Investigated methods for testing and evaluating the performance of optimized compilers.",
    image:
      "https://media.geeksforgeeks.org/wp-content/uploads/20200524115722/Capture3311.png",
    tags: ["Research Project"],
    category: "machine learning",
    github: "https://github.com/sagar10arya",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
      {
        name: "Shivam Yadav",
        img: "https://media.licdn.com/dms/image/D4D03AQG2iJK4dt6WkA/profile-displayphoto-shrink_400_400/0/1702140836050?e=1724284800&v=beta&t=arNpf3sbzKunxziycbv9YZB02qSrV1VH5REujuRWedk",
        linkedin: "https://www.linkedin.com/in/shivam-yadav-a35603275/",
        // github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 3,
    title: "Full Stack Web App",
    date: "March 2023 - April 2023",
    description:
      "Build a full stack web app having stunning UI with native mobile feel, special tech stack and infinite scroll feature and amazing performance. Learned and used Appwrite to handle backend must faster and much lower cost. Implemented robust and stunning authentication, pages for exploring posts, ability to like and save posts through a seperated dedicated page integrated together with search functionality.",
    image: require("../images/full-stack.png"),
    tags: ["ReactJS", "CSS", "Appwrite"],
    category: "web app",
    github: "https://github.com/sagar10arya/full-stack-web-app",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  {
    id: 4,
    title: "Weather Forecast Web App",
    date: "January 2024",
    description:
      "Developed a web app to provide real-time weather forecasts. Implemented search functionality to fetch weather data from weather API and display current conditions for cities worldwide.",
    image: require("../images/weather.png"),
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sagar10arya/Weather-Forecast?tab=readme-ov-file",
    webapp: "https://yours-weather-forecast.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  {
    id: 5,
    title: "Rock Paper Scissor Game",
    date: "January 2024",
    description:
      "For real-time interactive engagement between gamer and the computer. Provides near-instantaneous replies.",
    image: require("../images/rockPpaerScissor.png"),
    tags: ["HTML", "CSS", "Javascript"],
    category: "games",
    github: "https://github.com/sagar10arya/Games/tree/main/RockPaperScissor",
    webapp: "https://playing-rock-paper-scissors.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  {
    id: 6,
    title: "Chess Game",
    date: "August-November 2021",
    description:
      "For real-time chess game with interactive UI",
    image: require("../images/chess.jpg"),
    tags: ["C++"],
    category: "games",
    github: "https://github.com/sagar10arya/Chess-Project",
    // webapp: "https://playing-rock-paper-scissors.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/D5603AQG-I4kYz2GcEQ/profile-displayphoto-shrink_400_400/0/1718334521242?e=1724284800&v=beta&t=6HF4uTGVl2ewZ2BU0SUoK79BXdKor1P53WMfqUu8pzw",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },
];
